import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';
import { getLatestArticles } from '@/utils/content';

export default function HeroSection() {
  const tickerItems = getLatestArticles(8);

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20midnight%20city%20alley%20with%20warm%20amber%20neon%20glow%20and%20drifting%20fog%2C%20deep%20charcoal%20and%20crimson%20tones%2C%20moody%20artistic%20night%20photography%20with%20strong%20negative%20space%2C%20cinematic%20and%20minimal&width=1800&height=1000&seq=shenye-hero-main-01&orientation=landscape"
          alt="深夜城市街景中的暖色灯光，象征深夜爆料的第一手线索"
          title="深夜爆料 第一手独家 新瓜速递"
          className="h-full w-full object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/85 via-background-950/70 to-background-50"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 via-background-950/40 to-transparent"></div>
      </div>

      <div className="relative z-10 mx-auto w-full px-4 pb-0 pt-28 md:px-10 md:pt-36">
        <div className="max-w-3xl animate-rise">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-accent-500/40 bg-accent-500/10 px-3.5 py-1.5 text-xs text-accent-300">
            <span className="relative flex h-2 w-2 items-center justify-center">
              <span className="absolute h-2 w-2 rounded-full bg-accent-500 animate-live"></span>
              <span className="h-1.5 w-1.5 rounded-full bg-accent-400"></span>
            </span>
            今夜已更新 12 条 · 首发 5 条
          </div>

          <h1 className="font-heading text-3xl font-black leading-[1.2] text-foreground-50 text-glow md:text-5xl">
            深夜爆料，第一手独家
            <br />
            <span className="text-primary-400">新瓜速递在这里抢先看</span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-300 md:text-base">
            {siteInfo.name}新料首发专区，聚焦第一手独家内容。我们把凌晨到天亮这段时间交给线索，也交给还没睡的你——想抢先看最新爆料、掌握首发动态，点进来就能找到热乎的料。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#spotlight"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-950 transition-colors hover:bg-primary-400"
            >
              <i className="ri-flashlight-fill"></i>
              看今晚的爆点
            </a>
            <a
              href="#subscribe"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 bg-background-950/40 px-6 py-3 text-sm text-foreground-200 backdrop-blur transition-colors hover:border-primary-500/60 hover:text-primary-300"
            >
              <i className="ri-notification-3-line"></i>
              订阅首发提醒
            </a>
          </div>
        </div>

        <dl className="mt-12 grid grid-cols-2 gap-x-6 gap-y-6 border-t border-background-300/30 py-8 md:grid-cols-4">
          {siteInfo.stats.map((item) => (
            <div key={item.label}>
              <dt className="text-xs text-foreground-500">{item.label}</dt>
              <dd className="mt-1.5 font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
                {item.value}
                <span className="ml-1 text-xs font-normal text-foreground-500">{item.unit}</span>
              </dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="relative z-10 w-full border-y border-background-200/70 bg-background-100/70 backdrop-blur">
        <div className="flex items-center">
          <span className="flex shrink-0 items-center gap-2 border-r border-background-200/70 px-4 py-3 text-xs font-medium text-primary-400 md:px-10">
            <i className="ri-live-line"></i>
            实时速递
          </span>
          <div className="relative flex-1 overflow-hidden py-3">
            <div className="flex w-max animate-ticker items-center">
              {[...tickerItems, ...tickerItems].map((item, index) => (
                <Link
                  key={`${item.id}-${index}`}
                  to={`/article/${item.id}`}
                  className="mx-6 inline-flex shrink-0 items-center gap-2 whitespace-nowrap text-sm text-foreground-400 transition-colors hover:text-primary-400"
                >
                  <span className="text-primary-400">{item.liveTime}</span>
                  {item.title}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}